<div class="dialog-container">
  <div mat-dialog-content>
    <h1>Search result</h1>
    <div>
      <table mat-table [dataSource]="data.tags" class="mat-elevation-z2 results-table">
        <!-- CommPkg -->
        <ng-container matColumnDef="cpNumber">
          <th mat-header-cell *matHeaderCellDef>CommPkg</th>
          <td mat-cell *matCellDef="let item">
            <button mat-button color="primary" class="link" (click)="navToCp(item)">{{ item.tag.commissioningPackage?.cpNumber }}</button>
          </td>
        </ng-container>

        <!-- McPackage -->
        <ng-container matColumnDef="mcpNumber">
          <th mat-header-cell *matHeaderCellDef>McPackage</th>
          <td mat-cell *matCellDef="let item">
            <button mat-button color="primary" class="link" (click)="navToMcp(item)">{{ item.tag.mcPackage?.mcpNumber }}</button>
          </td>
        </ng-container>

        <!-- Tag Number -->
        <ng-container matColumnDef="tagNumber">
          <th mat-header-cell *matHeaderCellDef>Tag Number</th>
          <td mat-cell *matCellDef="let item">
            <button mat-button color="primary" class="link" (click)="navToCsa(item)">{{ item.tag.tagNumber }}</button>
          </td>
        </ng-container>

        <!-- Check Sheet -->
        <ng-container matColumnDef="checkSheet">
          <th mat-header-cell *matHeaderCellDef>Check Sheet</th>
          <td mat-cell *matCellDef="let item">
            <button mat-button color="primary" class="link" (click)="navToCsa(item)">{{ item.checkSheet.csNumber }}</button>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let item">
            <app-status-circle [status]="getCompletionStatus(item.status)"></app-status-circle>
          </td>
        </ng-container>

        <!-- Signed -->
        <ng-container matColumnDef="signedBy">
          <th mat-header-cell *matHeaderCellDef>Signed</th>
          <td mat-cell *matCellDef="let item">
            {{ item.signedBy?.user.name }}
          </td>
        </ng-container>

        <!-- Verified -->
        <ng-container matColumnDef="verifiedBy">
          <th mat-header-cell *matHeaderCellDef>Verified</th>
          <td mat-cell *matCellDef="let item">
            {{ item.verifiedBy?.user.name }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [attr.data-rowid]="row?.id"></tr>
      </table>
    </div>
  </div>
  <div mat-dialog-actions>
    @if (data.isCancelDisplay) {
      <button mat-button mat-stroked-button mat-dialog-close data-testid="dialog-cancel">Cancel</button>
    }
    <button mat-raised-button [mat-dialog-close]="true" name="confirm-btn" color="primary" data-testid="dialog-confirm">
      {{ data.confirmationTile }}
    </button>
  </div>
</div>
